import { render, staticRenderFns } from "./CollapsibleLinks.vue?vue&type=template&id=4b0c93fd"
import script from "./CollapsibleLinks.vue?vue&type=script&lang=js"
export * from "./CollapsibleLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports